import { object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { userSettingAcrissFormData } from "../@signals"


const schema = object({
	color: string().required('Color is required'),
	acriss_code: string().required('ACRISS is required'),
})

export default function useUserSettingsAcrissValidator() {
	const { isValid, errors } = useValidatorSeeker(userSettingAcrissFormData.value, schema)

	return {
		isValid,
		colorError: errors.color || null,
		acrissError: errors.acriss_code || null
	}
}